// extracted by mini-css-extract-plugin
export default {"root":"style_root__DvC4I","grid-row":"style_grid-row__-dcxj"};